"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TrailingZeroDisplay;
(function (TrailingZeroDisplay) {
    TrailingZeroDisplay["HIDE_IF_WHOLE"] = "hide_if_whole";
    TrailingZeroDisplay["AUTO"] = "auto";
})(TrailingZeroDisplay || (TrailingZeroDisplay = {}));
exports.default = TrailingZeroDisplay;
